export const getDomain = () => {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get("domain");
};
